import { useState } from "react";
import { useWizard } from "react-use-wizard";
import { IFillDataWizardTradeIn } from "..";
import { useNavigate } from "react-router-dom";
import tradeInSteps from "./tradeInSteps";
import BaseStep from "../../../../../shared/wizard/steps/baseStep";
import AuthModal from "../../../../auth/components/modals/authModal";
import useDealRequestExchange, {
  EDealRequestLinkType,
} from "../../../../../../api/hooks/use-deal-request-exchange";
import { getAccessToken } from "../../../../../../lib/services/localStorage.service";
import { toast } from "react-toastify";
import { PATHS } from "../../../../../shared/constants";
import { EMarketTypes } from "../../../../../../interfaces";
import Button from "../../../../../ui/button";
import useOpenModal from "../../../../../ui/modal/hooks/useOpenModal";

interface ITradeInStep_10 {
  data: IFillDataWizardTradeIn;
  isTripleStepPrev: boolean;
}

const TradeInStep_10 = ({ data, isTripleStepPrev }: ITradeInStep_10) => {
  const { goToStep } = useWizard();

  const navigate = useNavigate();

  const handlePrevStep = () => {
    if (isTripleStepPrev) {
      goToStep(tradeInSteps.step_7.step);
    } else {
      goToStep(tradeInSteps.step_9.step);
    }
  };

  const {
    data: dataDealRequest,
    error,
    isMutating,
    trigger,
  } = useDealRequestExchange();

  const { offsetY, open, handleChangeModal } = useOpenModal();

  const handleSendData = async () => {
    if (getAccessToken()) {
      try {
        await trigger({
          type: EDealRequestLinkType.TradeIn,
          data,
          marketType: EMarketTypes.SECONDARY,
        });
        toast.success("Заявка на ТРЕЙД-ИН создана");
        navigate(`/${PATHS.myDeal}`);
      } catch (error: any) {
        if (error?.message === "Unauthorized") {
          handleChangeModal(true);
        }
        toast.error("Ошибка не удалось отправить заявку");
      }
    } else {
      handleChangeModal(true);
    }
  };

  return (
    <div>
      <BaseStep
        counterPage={{
          current: tradeInSteps.step_10.page,
          max: tradeInSteps.step_10.maxPage,
        }}
        prevStep={handlePrevStep}
        text="Отправьте заявку  мы подберем вам  квартиру, организуем трейд-ин и решим юридические вопросы:"
      >
        <div>
          <Button
            label="Отправить заявку на покупку"
            onClick={handleSendData}
          />
          <AuthModal
            opened={open}
            onClose={(value) => handleChangeModal(value)}
            offsetY={offsetY}
          />
        </div>
      </BaseStep>
    </div>
  );
};

export default TradeInStep_10;
